import React, { useEffect } from "react";
import { Select } from "antd";
import { useRequest } from "ahooks";
import { api } from "@/redux/api";

const fetchUsers = (search) => {
  return api.filterCustomUsers(search).then((res) => {
    const results = res?.data?.results ?? [];
    return results.map((item) => {
      return {
        value: item.id,
        label: item.username,
      };
    });
  });
};

export const UserSelect = (props) => {
  const { value, onChange } = props;

  const {
    data: users = [],
    run: searchUsers,
    loading,
  } = useRequest(fetchUsers, {
    debounceWait: 300,
    manual: true, // 不自动执行，等待初始化或搜索时调用
  });

  // 组件挂载时加载用户列表
  useEffect(() => {
    searchUsers();

    // 如果有初始值，可以加载特定用户信息
    if (value && typeof value === "number") {
      searchUsers(`id=${value}`);
    }
  }, []);

  const handleSearch = (inputValue) => {
    if (!inputValue) {
      searchUsers();
      return;
    }
    searchUsers(`username=${inputValue}`);
  };

  return (
    <Select
      {...props}
      loading={loading}
      showSearch
      allowClear
      options={users}
      filterOption={false}
      onSearch={handleSearch}
      defaultActiveFirstOption={false}
      notFoundContent={null}
    />
  );
};
